"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TwilioVoicemailDetectionVoicemailDetectionTypesItem = void 0;
exports.TwilioVoicemailDetectionVoicemailDetectionTypesItem = {
    MachineStart: "machine_start",
    Human: "human",
    Fax: "fax",
    Unknown: "unknown",
    MachineEndBeep: "machine_end_beep",
    MachineEndSilence: "machine_end_silence",
    MachineEndOther: "machine_end_other",
};
